<template>
  <div class="gp-tabs-content">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "GpTabsContent"
};
</script>